var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeaderCloseIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 12 11.9997",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.777723 11.9997C0.5787 11.9997 0.379532 11.9236 0.228069 11.772C-0.076023 11.468 -0.076023 10.9766 0.228069 10.6727L10.6727 0.22796C10.9766 -0.0759865 11.468 -0.0759865 11.772 0.22796C12.076 0.531906 12.076 1.02332 11.772 1.32727L1.32738 11.772C1.25532 11.8443 1.16966 11.9017 1.07532 11.9408C0.980982 11.9799 0.879839 11.9999 0.777723 11.9997Z",
    fill: "url(#paint0_linear_0_4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.2223 11.9997C11.0233 11.9997 10.8243 11.9236 10.6727 11.772L0.228069 1.32727C-0.076023 1.02332 -0.076023 0.531869 0.228069 0.22796C0.532015 -0.0759865 1.02329 -0.0759865 1.32738 0.22796L11.772 10.6727C12.076 10.9766 12.076 11.4681 11.772 11.772C11.6204 11.9243 11.4213 11.9997 11.2223 11.9997Z",
    fill: "url(#paint1_linear_0_4)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_4",
    x1: 4.76923,
    y1: 11.9997,
    x2: 4.76923,
    y2: 1.49042e-8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A04D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF00F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_4",
    x1: 4.76923,
    y1: 11.9997,
    x2: 4.76923,
    y2: 1.49042e-8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A04D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF00F2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderCloseIcon);
export default __webpack_public_path__ + "static/media/header-close-icon.1271b594e2e894d9219ecd0d7b84efac.svg";
export { ForwardRef as ReactComponent };